import axios, { AxiosResponse } from 'axios';

import { BaseHttpService } from '~system/api/base/base-http-service';

export const refresh = async () => {
  // Keep refresh outside HttpService: its 401 must not enter the refresh
  // interceptor again and recursively attempt another refresh.
  const response: AxiosResponse<{ access_token: string }> = await axios.post(
    `${BaseHttpService.baseUrl}/auth/refresh`,
    null,
    {
      withCredentials: true,
    },
  );

  return response.data;
};
